// extracted by mini-css-extract-plugin
export default {"dialogTitle":"Qm622","dialog":"iPsoT","container":"skA45","emptyField":"xHg9O","addNewItemButton":"f1SB5","paymentTable":"jxl1U","totalRow":"M6cU2","label":"pnbnS","value":"ScyBf"};